/**
 * line 공유하기
 * @param shareUrl
 */
let shareLine = (shareUrl = location.href) =>{
    let url = `https://lineit.line.me/share/ui?url=${encodeURIComponent(shareUrl)}`;
    window.open(url);
};

export default shareLine;